module.exports = new __parcel__URL__("Charlie_Text-Light_Italic.72ed72e0.woff2").toString();